import * as Sentry from '@sentry/browser';
import {DEFAULT_LOCALE, getUserData} from './API';
import { func } from 'prop-types';
import { logSentryException } from './util';

export function isMicAllowed(){
  if(!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia || !navigator.mediaDevices.enumerateDevices){
    return Promise.resolve(false);
  }

  if(!getUserData().sessionData.isiPad){
    return navigator.mediaDevices.getUserMedia({audio: true})
    .then((stream)=>{
      return Promise.resolve(stream ? true : false);
    })
    .catch((err)=>{
      console.log("MIC NOT ALLOWED",err);
      logSentryException(new Error('Microphone access denied'), 'Error MIC NOT ALLOWED', { originalError: err?.message, originalStack: err?.stack });
      return Promise.resolve(false);
    });
  }else{
    return navigator.mediaDevices.enumerateDevices().then((devices) => {
      for(let i = 0; i < devices.length; i++){
        let device = devices[i];
        if(device.kind == "audioinput" && device.label){
          return Promise.resolve(true);
        }
      }
      return Promise.resolve(false);
    }).catch((err) =>{
      logSentryException(new Error('Device enumeration failure'), 'Error enumerateDevices', { originalError: err?.message, originalStack: err?.stack });
      return Promise.resolve(false);
    });
  }
}

export function isiPad(){
  return  ((navigator.userAgent.match(/iPad/i) != null /* iOS pre 13 */ ||
          (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) /* iPad OS 13 */ ||
          (navigator.platform === 'iPad')
          ));
}

export function supportsSpeechRec(browser){
  console.log(browser)
  let name = browser.name.toLowerCase();
  let version = browser.version;

  return( ((name === 'chrome') && !isiPad()) ||
          ((name === 'safari') && !isiPad() && (version >= "14.1"))
  );
}
const validLocales = [
  'en-us',
  'es-mx',
]

export function getUserLocale() {
  // Fetch device locale as fallback
  let userDataLocale = window.navigator.language.toLowerCase(); // navigator.language returns something like en-US

  if (!validLocales.includes(userDataLocale)) { // Make sure we support the device's default locale
    userDataLocale = DEFAULT_LOCALE;
  }

  // If we have a locale set in userData, have that override device locale
  const userData = getUserData();
  if (userData && userData.locale) {
    userDataLocale = userData.locale;
  }

  return userDataLocale;
}
